import { MaterialTypes, TypeCodes } from 'constants/data'
import { A_wf_openWebinar, originFWebinar } from '../webinars/webinar_future'
import { A_wp_openWebinar, originPWebinar } from '../webinars/webinar_past'
import { A_art_openArticle, originArticle } from './article'
import { A_lec_openLectures, originLectures } from './lectures'
import { A_cr_openClinRec, originClinRec } from './clinrec'
import { A_p_openPodcast } from './podcast'
import { lectorOrigin } from '../other/sub_lector/sub_lector'

const A_clickNewsline = (
  origin:
    | originArticle
    | originLectures
    | originFWebinar
    | originPWebinar
    | originClinRec
    | lectorOrigin,
  id: number,
  materialType?: MaterialTypes,
  ArticleTypeId?: number
) => {
  if (materialType === MaterialTypes.FUTURE_WEBINAR) A_wf_openWebinar(origin as originFWebinar, id)
  if (materialType === MaterialTypes.WEBINAR) A_wp_openWebinar(origin as originPWebinar, id)
  if (materialType === MaterialTypes.PODCAST) return A_p_openPodcast()
  if (ArticleTypeId === TypeCodes.VIDEO) A_lec_openLectures(origin as originLectures, id)
  if (ArticleTypeId === TypeCodes.ARTICLE) A_art_openArticle(origin as originArticle, id)
  if (ArticleTypeId === TypeCodes.CLINIC) A_cr_openClinRec(originClinRec.CLINICAL_LIST, id)
  //   if (ArticleTypeId === TypeCodes.CLINIC_CASE) return MaterialsType.CLINIC_CASE
  return ''
}

export { A_clickNewsline }
